'use strict';

/**
 * stores module
 */
require(['vue', 'storeViewApp', 'vueLazyload', 'vueInfiniteScroll', 'modal', 'es6PromiseAuto', 'polyfill'], function (Vue, storeViewApp, VueLazyload, vueInfiniteScroll, VModal) {
  /* eslint no-new: "off" */
  Vue.config.productionTip = false;
  Vue.use(VueLazyload, {
    preLoad: 1.3,
    loading: require.toUrl('images/spinner.svg'),
    attempt: 2
  });
  Vue.use(vueInfiniteScroll);
  // 使用modal
  Vue.use(VModal.default, { componentName: 'modal' });
  // 实例化vue
  new Vue({
    el: '#app',
    template: '<storeViewApp/>',
    components: {
      storeViewApp: storeViewApp
    }
  });
});
define("Transsion_Pickup/modules/stores-view", function(){});

